import { SKY_BLUE, MUTED_TEXT, HEADER_TEXT, LIGHT_BLUE_BG } from './constants';

export const cardTitleSx = {
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: '0%',
    color: HEADER_TEXT,
};

export const tableHeaderSx = {
    fontSize: '14px',
    fontWeight: 500,
    color: '#000000',
    mb: 1,
};

export const dropdownSx = {
    height: '32px',
    backgroundColor: LIGHT_BLUE_BG,
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: MUTED_TEXT,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: SKY_BLUE,
    },
    fontSize: '14px',
    borderRadius: '4px',
    '& .MuiSelect-select': {
        color: HEADER_TEXT,
        fontWeight: 500,
    },
};

export const searchFieldSx = {
    width: '588px',
    '& .MuiOutlinedInput-root': {
        height: '32px',
        left: '40px',
        backgroundColor: LIGHT_BLUE_BG,
        fontSize: '13px',
        borderRadius: '4px',
        '& fieldset': {
            borderColor: 'transparent',
        },
        '& .MuiInputBase-input::placeholder': {
            color: MUTED_TEXT,
            opacity: 1,
        },
    },
};

export const iconBtnSx = (color: string) => ({
    border: `0.8px solid ${color}`,
    borderRadius: '4px',
    width: '32px',
    height: '32px',
    p: '8px 12px',
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiSvgIcon-root': {
        fontSize: '18px',
        color: color,
    },
});
